module.exports = __webpack_public_path__ + "static/media/marquise_diamond.5bda5a25.png";